import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IRunCreateExtractsOnDatasourcesParams extends IMultipleIdsParams {
  encrypt: boolean;
}

export class RunCreateExtractsOnDatasourcesRequest extends Request<IRunCreateExtractsOnDatasourcesParams, IResult> {
  constructor(ids: string[], encrypt: boolean) {
    super('runCreateExtractsOnDatasources', {
      ids: ids,
      encrypt: encrypt
    });
  }
}
